// extracted by mini-css-extract-plugin
export default {"title":"_68ab905bd1","inner_title":"de9f16e61f","charge_btn":"daf77ad9b5"};